<template>
  <Modal
    ref="modal"
    bgcolor="rgba(0,0,0,0.3)"
  >
    <div class="not-support-wrwapper">
      <i
        class="isif isif-close"
        @click="hide"
      />
      <span
        class="copied-message"
        :class="{ 'active': alreadyCopied }"
      >
        {{ $t('Copied') }}
      </span>
      <div class="not-support-wrwapper-container">
        <img
          class="not-support-image"
          :src="noSupportedImage"
          alt="Not Supported"
        >
        <span
          class="not-support-title"
          v-text="$t('WebRTCNotSupportTitle')"
        />
        <button
          v-if="isClipboardSupport"
          ref="copyButton"
          class="copy-button"
          :data-clipboard-text="copyUrl"
          @click="copy"
          v-text="$t('WebRTCNotSupportCopyButton')"
        />
        <p
          class="not-support-text"
          v-text="WebRTCNotSupportDesc"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import ClipboardJS from 'clipboard'
import Modal from '../../../IModal/index'
import {
  isMobile,
  isIOS
} from '../../../../api/utils'

export default {
  name: 'ModalWebRtcNotSupport',

  components: {
    Modal
  },

  data () {
    return {
      alreadyCopied: false,
      alreadyCopiedTimer: null,
      duration: 3000,
      noSupportedImage: require('../../../../../src/assets/images/warning.png'),
      isClipboardSupport: ClipboardJS.isSupported(),
      copyButtonEl: null,
      copyUrl: ''
    }
  },

  computed: {
    WebRTCNotSupportDesc () {
      if (isMobile()) {
        return isIOS() ? this.$t('WebRTCNotSupportDesciOS') : this.$t('WebRTCNotSupportDescAndroid')
      }
      return this.$t('WebRTCNotSupportDesc')
    }
  },

  mounted () {
    this.copyUrl = window.location.href
  },

  methods: {
    show () {
      this.$refs.modal.show()
      setTimeout(() => {
        if (this.$refs.copyButton) {
          this.copyButtonEl = new ClipboardJS(this.$refs.copyButton)
        } else {
          console.warn('Copy button not found, maybe the button can\'t copy')
        }
      }, 0)
    },

    hide () {
      this.$refs.modal.hide()
    },

    copy () {
      if (this.isClipboardSupport) {
        this.alreadyCopied = true
        if (this.alreadyCopiedTimer) {
          window.clearTimeout(this.alreadyCopiedTimer)
        }
        this.alreadyCopiedTimer = window.setTimeout(() => {
          this.alreadyCopied = false
        }, this.duration)
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';

.not-support-wrwapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 95%;
  max-height: 95%;
  width: 46.5rem;
  height: 31.75rem;
  padding: 1.75rem;
  background-color: $light-gray-color2;
  box-shadow: 0 2px 30px 0 rgba(124, 124, 124, 0.5);

  @media (max-width: $response) {
    width: 100%;
    height: 100%;
    max-width: 100vw;
    max-height: 100vh;
  }

  .isif-close {
    position: absolute;
    cursor: pointer;
    top: 1.5rem;
    right: 1.5rem;
    font-size: 1.2rem;
  }

  .copied-message {
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 32px;
    color: $white;
    background-color: rgba(88, 88, 90, 0.8);
    border-radius: 5px;
    opacity: 0;
    transition: linear 0.3s;

    &.active {
      opacity: 1;
    }
  }

  .not-support-wrwapper-container {
    width: 26.25rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .not-support-image {
    width: 78px;
    height: 78px;
  }

  .not-support-title {
    font-size: 1.25rem;
    color: $light-gray-color;
    margin-top: 1.5rem;
    text-shadow: none;
  }

  .copy-button {
    margin-top: 2.4rem;
    padding: 0.3rem 1.5rem;
    background-color: $yellow;
    font-size: 1rem;
    border-radius: 0.3rem;
    box-shadow: 0 2px 5px 0 rgba(124, 124, 124, 0.5);
  }

  .not-support-text {
    margin-top: 2.4rem;
    color: $light-gray-color;
    text-shadow: none;
    line-height: 1.5rem;
  }
}
</style>
